"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_polyglot_1 = require("react-polyglot");
const LabelUtils_1 = __importDefault(require("./LabelUtils"));
const translateWrapper = () => {
    return (WrappedComponent) => {
        return (0, react_polyglot_1.translate)()(({ t, ...props }) => {
            const customT = (label, data) => {
                const customLabel = LabelUtils_1.default.customize(label, data);
                const resolvedLabel = t(customLabel, (data === null || data === void 0 ? void 0 : data.data) || data);
                if ((data === null || data === void 0 ? void 0 : data.fallback) && resolvedLabel === customLabel) {
                    return t(data.fallback, (data === null || data === void 0 ? void 0 : data.data) || data);
                }
                return resolvedLabel;
            };
            return (0, jsx_runtime_1.jsx)(WrappedComponent, { ...props, t: customT });
        });
    };
};
exports.default = translateWrapper;
